import {
  BaseSyntheticEvent,
  useState,
  useEffect
} from 'react';

interface Props {
  min: number;
  max: number;
  step: number;
  defaultValue?: number;
  passValue?: (val: number) => void;
}

function InputRange({
  min,
  max,
  step,
  defaultValue = 0,
  passValue
}: Props) {
  const [value, setValue] = useState(defaultValue);
  const [progress, setProgress] = useState<null | number>(
    value / max
  );

  useEffect(() => {
    setProgress(value / max);
  }, [value]);

  function handleChange(e: BaseSyntheticEvent) {
    setValue(Number(e.target.value));
    if (passValue !== undefined) passValue(e.target.value);
  }

  return (
    <input
      className="text-[10px]"
      type="range"
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={handleChange}
      style={
        {
          '--val': progress && Math.round(progress * 100)
        } as React.CSSProperties
      }
    />
  );
}

export default InputRange;
